import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../../store';
import { get, post, put } from '../../../inteceptor';
import moment from 'moment';

const initialState = {
  error: null,
  time: null,
  data: [],
  grnPaymentList: [],
  cashFlowMainCategories: [],
  cashFlowSubCategories: [],
  cashBalance: [],
  addData: {},
  sorted: [],
};

const slice = createSlice({
  name: 'Cashflow',
  initialState,
  reducers: {
    hasError(state, action) {
      state.error = { message: action.payload, time: moment.now().toString() };
    },

    getGrnPaymentListSuccess(state, action) {
      state.grnPaymentList = action.payload.data;
    },

    getCashFlowsSuccess(state, action) {
      state.data = action.payload.data;
    },

    getCashFlowMainCategoriesSuccess(state, action) {
      state.cashFlowMainCategories = action.payload.data;
    },

    getCashFlowSubCategoriesSuccess(state, action) {
      state.cashFlowSubCategories = action.payload.data;
    },

    getPreviousCashBalanceSuccess(state, action) {
      state.cashBalance = action.payload.data;
    },

    addOrUpdateCashFlows(state, action) {
      state.addData = {
        data: action.payload.data,
        time: moment.now().toString(),
      };
    },

    clearAll(state) {
      state.addData = {};
      state.error = {};
    },

    onBackStep(state) {
      state.checkout.activeStep -= 1;
    },

    onNextStep(state) {
      state.checkout.activeStep += 1;
    },

    onGotoStep(state, action) {
      const goToStep = action.payload;
      state.checkout.activeStep = goToStep;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { filterCategories } = slice.actions;

// ----------------------------------------------------------------------

export function getGrnPaymentList(locationId) {
  return async () => {
    try {
      const response = await get(`getGrnPaymentList?locationId=${locationId}`);
      if (response.status) {
        dispatch(slice.actions.getGrnPaymentListSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function handleGrnPaymentApproval(data) {
  return async () => {
    try {
      const response = await put(`handleGrnPaymentApproval`, data);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateCashFlows(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getCashFlowLedger(locationId, mainCategoryId) {
  return async () => {
    try {
      const response = await get(`getCashFlowLedger?locationId=${locationId}&mainCategoryId=${mainCategoryId}`);
      if (response.status) {
        dispatch(slice.actions.getCashFlowsSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function verifyDrawerCloseAmounts(body) {
  return async () => {
    try {
      const response = await post(`verifyDrawerCloseAmounts`,body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateCashFlows(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getCashFlows(locationId, isTransfer = false) {
  return async () => {
    try {
      const response = await get(`Cashflow?locationId=${locationId}&isTransfer=${isTransfer}`);
      if (response.status) {
        dispatch(slice.actions.getCashFlowsSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getCashFlowMainCategories() {
  return async () => {
    try {
      const response = await get(`cashFlowMainCategories`);
      if (response.status) {
        dispatch(slice.actions.getCashFlowMainCategoriesSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getCashFlowSubCategories() {
  return async () => {
    try {
      const response = await get(`cashFlowSubCategories`);
      if (response.status) {
        dispatch(slice.actions.getCashFlowSubCategoriesSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getPreviousCashBalance(locationId, date) {
  return async () => {
    try {
      const response = await get(`previousCashBalance?locationId=${locationId}&date=${date}`);
      if (response.status) {
        dispatch(slice.actions.getPreviousCashBalanceSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getForPaymentDateRange(locationId, startDate, endDate, isTransfer = false) {
  return async () => {
    try {
      const response = await get(`getForPaymentDateRange?locationId=${locationId}&isTransfer=${isTransfer}&startDate=${startDate}&endDate=${endDate}`);
      if (response.status) {
        dispatch(slice.actions.getCashFlowsSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function addCashFlows(body) {
  return async () => {
    try {
      const response = await post(`addGrnPaymentList`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateCashFlows(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function updateCashFlows(body) {
  return async () => {
    try {
      const response = await put(`updateGrnPaymentList`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateCashFlows(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
